module.exports = __webpack_public_path__ + "img/icon_t2_c.0fa1622b.png";